import { H3 } from '@liveauctioneers/hammer-ui-core/text';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { addImageParams, AddImageParamTypes } from '@/utils/urls';

type Props = {
    imageUrl: string;
    link: string;
    title: string;
};

export const CategoryModuleCard = ({ imageUrl, link, title }: Props) => {
    const imageParams: AddImageParamTypes = {
        height: 160,
        url: imageUrl,
    };

    return (
        <div className="min-w-0 smMin:flex-1">
            <RouteLink
                className="relative flex w-full flex-col items-center gap-xs bg-background-primary no-underline smMin:gap-md"
                to={link}
            >
                <div className="relative block w-full justify-center overflow-hidden bg-background-subdued p-xs smMin:px-md smMin:py-sm">
                    <img
                        alt={title}
                        className="w-full"
                        loading="lazy"
                        src={addImageParams(imageParams)}
                    />
                </div>
                <H3>{title}</H3>
            </RouteLink>
        </div>
    );
};
